/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

/**
 * Declare Variable
 */
const defaultState = {
  params: {},
}

/**
 * Export
 */
export const query = handleActions({
  UPDATE_PARAMS: (state, action) => {
    return update(state, {
      params: { $set: action.payload },
    })
  },
}, defaultState)

export default {
  query,
}



// WEBPACK FOOTER //
// ./src/reducers/components/query.js